import { LocalStorageKey } from '@/hooks/storage/useLocalStorage';
import { TABLE_BET_KEY } from '@/hooks/useTableBet';
import { StateMsgType } from '@/models/Popup';
import { GameError } from '@/models/games/enums/GameError';
import { GameType } from '@/models/games/enums/GameType';
import { BetFormat } from '@/models/host/BetAmount';
import { betAnalyticThunk } from '@/modules/analytic/thunk';
import {
    getTableBetByHostId,
    tableBetSliceActions,
} from '@/modules/betTable/slice';
import { getHostByGameId } from '@/modules/host/slice';
import { getMainUserState } from '@/modules/main/selector';
import {
    getLiveDataState,
    LiveDataSliceActions,
} from '@/modules/main/slice/liveData';
import { playerSliceActions } from '@/modules/main/slice/player';
import { inGamePopupSliceActions } from '@/modules/popup/inGameSlice';
import store from '@/store/store';
import { getWithHold } from '@/utils/commonFunc';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { CMDSpNbsBetResult, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpNbsBetResultHandler extends AbstractHandler {
    _command: CMDSpNbsBetResult;
    _specialMsg: string;
    _isMessageExist: (key: string) => boolean;

    constructor(
        command: ICommand,
        specialMsg: string,
        isMessageExist: (key: string) => boolean
    ) {
        super();
        this._command = command as CMDSpNbsBetResult;
        this._specialMsg = specialMsg;
        this._isMessageExist = isMessageExist;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handle(dispatch: Dispatch<any>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        if (host) {
            const { GameId, isBetConfirmed } = getTableBetByHostId(
                state,
                host.HostId
            );
            if (this._command.betFormat === BetFormat.AUTO_BET_CONFIRMED) {
                window.localStorage.removeItem(
                    `${TABLE_BET_KEY}_${host.HostId}`
                );

                if (this._command.Reason == this.SUCCESS_CODE) {
                    const { Username } = getMainUserState(state);
                    const hostIds = localStorage.getItem(
                        LocalStorageKey.RecentlyPlayed + Username
                    );
                    if (hostIds && hostIds.length > 0) {
                        let recentlyList = JSON.parse(hostIds)['hostIds'];
                        let recently = recentlyList.filter(
                            (h: { hostId: number }) => h.hostId != host.HostId
                        );
                        const newRecently = [{ hostId: host.HostId }]
                            .concat(recently)
                            .slice(0, 8);
                        localStorage.setItem(
                            LocalStorageKey.RecentlyPlayed + Username,
                            JSON.stringify({ hostIds: newRecently })
                        );
                    } else {
                        localStorage.setItem(
                            LocalStorageKey.RecentlyPlayed + Username,
                            JSON.stringify({
                                hostIds: [{ hostId: host.HostId }],
                            })
                        );
                    }

                    localStorage.setItem(
                        LocalStorageKey.LastBetTs,
                        Date.now().toString()
                    );

                    const withHold = host
                        ? getWithHold(host.GameType)
                        : undefined;
                    let _tableTotalBet = 0;
                    let _totalWithHoldAmount = 0;
                    let Bets = new Array<number>();
                    this._command.Bet.forEach(bet => {
                        Bets[bet.Base.betType] = bet.Base.betAmount;
                        _tableTotalBet += bet.Base.betAmount;
                        if (withHold) {
                            const tmp = withHold.find(
                                v => v.Type == bet.Base.betType
                            );
                            if (tmp) {
                                _totalWithHoldAmount +=
                                    bet.Base.betAmount * tmp.Amount;
                            }
                        }
                    });
                    batch(() => {
                        const state = store.getState();
                        const { hostsBetInfo } = getLiveDataState(state);
                        const { BetSeqId } = getTableBetByHostId(
                            state,
                            host.HostId
                        );
                        const item = hostsBetInfo.find(
                            v => v.hostId === host.HostId
                        );
                        if (this._command.Bet.length > 0) {
                            dispatch(
                                playerSliceActions.updateBalanceLow(
                                    this._command.balanceLo
                                )
                            );
                            dispatch(
                                playerSliceActions.updateBalanceHigh(
                                    this._command.balanceHi
                                )
                            );
                            dispatch(
                                inGamePopupSliceActions.updateIsOpen({
                                    hostId: host.HostId,
                                    isOpen: true,
                                })
                            );
                            if (item && item.totalBetAmount > _tableTotalBet) {
                                dispatch(
                                    inGamePopupSliceActions.updateDataSet({
                                        hostId: host.HostId,
                                        key: 'abc.partial_bet_successful',
                                        gameType: host.GameType,
                                        stateMsgType:
                                            StateMsgType.betInfo_Warning,
                                        gameId: this._command.GameID,
                                    })
                                );
                            } else if (
                                BetSeqId > this._command.betSeqID &&
                                _tableTotalBet > 0
                            ) {
                                //handle fail clear before success
                                dispatch(
                                    inGamePopupSliceActions.updateDataSet({
                                        hostId: host.HostId,
                                        key: 'abc.partial_bet_successful',
                                        gameType: host.GameType,
                                        stateMsgType:
                                            StateMsgType.betInfo_Warning,
                                        gameId: this._command.GameID,
                                    })
                                );
                            } else {
                                dispatch(
                                    inGamePopupSliceActions.updateDataSet({
                                        hostId: host.HostId,
                                        key: 'system.bet_success',
                                        gameType: host.GameType,
                                        stateMsgType:
                                            StateMsgType.betInfo_Success,
                                        gameId: this._command.GameID,
                                    })
                                );
                            }
                        } else if (item && item.totalBetAmount > 0) {
                            //have bet but no success
                            dispatch(
                                inGamePopupSliceActions.updateIsOpen({
                                    hostId: host.HostId,
                                    isOpen: true,
                                })
                            );
                            dispatch(
                                inGamePopupSliceActions.updateDataSet({
                                    hostId: host.HostId,
                                    key: 'abc_failure_betlog.error_code.5',
                                    gameType: host.GameType,
                                    stateMsgType: StateMsgType.betInfo_Fail,
                                    gameId: this._command.GameID,
                                })
                            );
                            dispatch(
                                tableBetSliceActions.clearPendingBets({
                                    hostId: host.HostId,
                                    gameId: host.GameID,
                                    startGame: false,
                                })
                            );
                        }
                        dispatch(
                            tableBetSliceActions.updateConfirmedBets({
                                hostId: host.HostId,
                                gameId: this._command.GameID,
                                bets: Bets,
                            })
                        );
                        dispatch(
                            betAnalyticThunk({
                                command: this._command,
                                isNbs: true,
                            })
                        );
                        if (host.GameType === GameType.Baccarat) {
                            dispatch(
                                LiveDataSliceActions.updateBaccaratBetHistory({
                                    hostId: host.HostId,
                                    gameId: this._command.GameID,
                                    betsSummary: Bets,
                                })
                            );
                        }
                        dispatch(
                            LiveDataSliceActions.updateHostBetInfo({
                                hostId: host.HostId,
                                totalBetAmount: _tableTotalBet,
                                pendingBetAmount: 0,
                                totalWithHoldAmount: _totalWithHoldAmount,
                                pendingWithHoldAmount: 0,
                            })
                        );
                    });
                } else {
                    //Bet Fail
                    let errorMsg = `abc_failure_betlog.error_code.${this._command.Reason}`;
                    if (!this._isMessageExist(errorMsg)) {
                        errorMsg = 'abc_failure_betlog.error_common';
                    }
                    batch(() => {
                        dispatch(
                            inGamePopupSliceActions.updateIsOpen({
                                hostId: host.HostId,
                                isOpen: true,
                            })
                        );
                        dispatch(
                            inGamePopupSliceActions.updateDataSet({
                                hostId: host.HostId,
                                key: errorMsg,
                                gameType: host.GameType,
                                stateMsgType: StateMsgType.betInfo_Fail,
                                gameId: this._command.GameID,
                                params: {
                                    errorcode: this._command.Reason.toString(),
                                },
                            })
                        );
                        dispatch(
                            tableBetSliceActions.clearPendingBets({
                                hostId: host.HostId,
                                gameId: host.GameID,
                                startGame: false,
                            })
                        );
                        dispatch(
                            //update isBetConfirmed
                            tableBetSliceActions.updateConfirmedBets({
                                hostId: host.HostId,
                                gameId: this._command.GameID,
                                bets: [],
                            })
                        );
                        if (host.GameType === GameType.Baccarat) {
                            dispatch(
                                LiveDataSliceActions.updateBaccaratBetHistory({
                                    hostId: host.HostId,
                                    gameId: this._command.GameID,
                                    betsSummary: [],
                                })
                            );
                        }
                    });
                }
            }
            if (this._command.betFormat === BetFormat.AUTO_BET) {
                // response per bet
                if (this._command.Reason != this.SUCCESS_CODE) {
                    if (
                        this._command.Reason != GameError.InvalidBetMode &&
                        this._command.Reason != GameError.DuplicateOrderID
                    ) {
                        //InvalidBetMode not need to clear
                        //DuplicateOrderID not need to clear
                        batch(() => {
                            if (
                                GameId === this._command.GameID &&
                                !isBetConfirmed
                            ) {
                                let errorMsg = `abc_failure_betlog.error_code.${this._command.Reason}`;
                                if (!this._isMessageExist(errorMsg)) {
                                    errorMsg =
                                        'abc_failure_betlog.error_common';
                                }
                                dispatch(
                                    inGamePopupSliceActions.updateIsOpen({
                                        hostId: host.HostId,
                                        isOpen: true,
                                    })
                                );
                                dispatch(
                                    inGamePopupSliceActions.updateDataSet({
                                        hostId: host.HostId,
                                        key: errorMsg,
                                        gameType: host.GameType,
                                        stateMsgType: StateMsgType.betInfo_Fail,
                                        gameId: this._command.GameID,
                                        params: {
                                            errorcode:
                                                this._command.Reason.toString(),
                                        },
                                    })
                                );
                            }
                            dispatch(
                                tableBetSliceActions.clearPendingBets({
                                    hostId: host.HostId,
                                    gameId: this._command.GameID,
                                    startGame: false,
                                })
                            );
                            if (
                                host.GameType === GameType.Baccarat &&
                                !isBetConfirmed
                            ) {
                                dispatch(
                                    LiveDataSliceActions.updateBaccaratBetHistory(
                                        {
                                            hostId: host.HostId,
                                            gameId: this._command.GameID,
                                            betsSummary: [],
                                        }
                                    )
                                );
                            }
                        });
                    }
                }
            }
        }
    }
}
